import { FunctionComponent } from "react"
import { BrowserView, isDesktop } from "react-device-detect"
import LogoFull from "../components/logo-full"

type MobileGateProps = {
  children: React.ReactNode
}

const MobileWarning: FunctionComponent = () => {
  return (
    <div className="relative bg-base-white w-full h-[100dvh] flex flex-col pt-[calc(33vh)] px-8 pb-12 box-border items-center justify-start text-steelblue">
      <LogoFull />
      <p className="text-center text-xl md:text-3xl mt-6">
        Sorry, the Meseekna Simulation is not available on mobile devices.
      </p>
    </div>
  )
}

const MobileGate: FunctionComponent<MobileGateProps> = ({ children }) => {
  if (!isDesktop) {
    return <MobileWarning />
  } else {
    return <BrowserView>{children}</BrowserView>
  }
}

export default MobileGate
